import React from 'react'
import Slider from 'react-slick';
import {Grid, Row, Col} from 'react-bootstrap'
import Dimensions from 'react-dimensions'
import image1 from '../Images/image1.jpg'
import image2 from '../Images/image2.jpg'
import image3 from '../Images/image3.jpg'
import image4 from '../Images/image4.jpg'
import image5 from '../Images/image5.jpg'
import image6 from '../Images/image6.jpg'
import image7 from '../Images/image7.jpg'
// const win = Dimensions.get('window');

const settings = {
  dots: true,
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 2,
  autoplay: true,
  speed: 2000,
  autoplaySpeed: 2000,
  responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
};
const internals = {};

internals.styles = {
gallery: {

  maxWidth: '100%',
  height: 'auto'
},

}

const styles = {

  image: {
    flex: 1,

    objectFit: 'cover',
    width: '100%',
    border: '5px solid rgba(255,255,255,0.8)',
    outlineStyle: 'solid',
    outlineColor: 'rgba(255,255,255,0.8)',
    height: 'auto'
  }
};

class Gallery extends React.Component {
  render() {

    return (<div id='gallery' style = {internals.styles.gallery}>
      <div>  <h1>Gallery
      </h1></div>
      <br/>
      <br/>
      <br/>
      <Slider {...settings}>
        <div >
          <img style={styles.image}  src={image1} alt="image1"/>
        </div>
        <div >
          <img style={styles.image}  src={image2} alt="image2"/>
        </div>
        <div >
          <img style={styles.image}  src={image3} alt="image3"/>
        </div>
        <div >
          <img style={styles.image} src={image4} alt="image4"/>
        </div>
        <div >
          <img style={styles.image}  src={image5} alt="image5"/>
        </div>
        <div >
          <img style={styles.image}  src={image6} alt="image6"/>
        </div>
        <div >
          <img style={styles.image}  src={image7} alt="image7"/>
        </div>

      </Slider>
    </div>);
  }
}
export default Gallery;



// WEBPACK FOOTER //
// ./src/Gallery/Gallery.jsx